import PropTypes from 'prop-types';
import React from 'react';
import ImagePlaceholdered from '../../../shared/image-placeholdered';
import lessRequire from '../../../../config/less-require-resolver';

lessRequire('modules/dashboard/components/on-start-popup.less');

export default function NewPromoPopup({intl, data, onClose, landingLanguages}) {
	return (
		<div className="on-start-modal__container">
			<div className='on-start-modal__content-container'>
				<div className="on-start-modal__title">
					<h2 className='font-proxima-nova-bold'>{intl('Новые промоматериалы в офферах')}</h2>
				</div>
				<div className='on-start-modal__gallery-container'>
					{Object.entries(data).map(([key, value], index) => {
						const landingPages = value.filter(offer_domain => offer_domain.type === 'landing');
						const transitPages = value.filter(offer_domain => offer_domain.type === 'transit');
						return (
							<div key={index} className='on-start-modal__wrapper'>
								{ !!landingPages.length &&
									getOfferPromosItem(key, landingPages, 'landing', landingLanguages, intl)
								}
								{ !!transitPages.length &&
									getOfferPromosItem(key, transitPages, 'transit', landingLanguages, intl)
								}
							</div>
						);
					})}
				</div>
				<div className='on-start-modal__button-wrap'>
					<button onClick={() => onClose('newPromo')}>OK</button>
				</div>
			</div>
		</div>
	);
}

function getOfferPromosItem(key, value, type, landingLanguages, intl) {
	const redirect = (domain) => {
		window.open(`https://${domain}`, '_blank');
	};
	const title = `${type === 'landing' ? intl('Лендинги') : intl('Транзитки')}`;
	return (
		<div>
			<div className='on-start-modal__title on-start-modal__title_sticky'>
				<h3 className="font-proxima-nova-bold">{key} </h3>
				<h4 className="font-proxima-nova-regular on-start-modal__title-type"> {title}:</h4>
			</div>
			<ul className='on-start-modal__gallery'>
				{value.map((item, itemIndex) => {
					const languages = item.languages
						.reduce((acc, value) => (acc && `${acc}, `) + landingLanguages[value], '');
					return (
						<li onClick={() => redirect(item.domain)} key={itemIndex}
							className='on-start-modal__item'>
							<ImagePlaceholdered
								src={item.image}
								alt={item.type == 'landing' ? 'Landing Preview' : 'Transit Preview'}
								className='on-start-modal__item-image'
							/>
							<h4 className="font-proxima-nova-regular promo__title">
								{item.land_title}
							</h4>
							<h4 className="font-proxima-nova-regular">
								{`${intl('Язык')}: ${languages}`}
							</h4>
						</li>
					);
				})}
			</ul>
		</div>
	);
}

NewPromoPopup.propTypes = {
	data: PropTypes.object
};


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/dashboard/components/popups/new-promo-popup.js